import React from 'react'
import { Api } from '../../libs/api'
import CommentItem from './commentItem'

class Comment extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            cdata: {},
            isAll: 1,
            cmtTxt: '',
            f_stat: false,
            isPop: 0,
        }
    }

    componentDidMount() {
        this.getCmtList(15)
    }

    getCmtList = (ps, me) => {
        const pl = {
            idx_cat_evt: this.props.evtid,
            pageSize: ps,
            idx_member: me,
        }
        Api.getEvtWinComment(pl).then(rsp => {
            if (parseInt(rsp.data.code, 10) === 200) {
                this.setState({ cdata: rsp.data.data })
            }
        })
    }

    isAllList = n => {
        this.setState({ isAll: n })
        const my = n === 1 ? null : this.props.user.user_idx
        this.getCmtList(25, my)
    }

    chkTextValue = () => e => {
        this.setState({ cmtTxt: e.target.value })
    }

    postNewCmt = (num = null, mess = null, pnum = null) => {
        let mes = mess
        if (!mes) mes = this.state.cmtTxt
        const isAdm = this.props.user.user_auth === 4 ? 1 : null
        const fstat = this.state.f_stat ? 1 : 0
        const params = {
            idx_cat_evt: this.props.evtid,
            idx_member: this.props.user.user_idx,
            idx_b_manager: isAdm,
            f_stat: fstat,
            idx_threads: num,
            idx_parent: pnum,
            message: mes,
        }
        Api.pushEvtWinComment(params).then(rsp => {
            if (parseInt(rsp.data.code, 10) === 200 && rsp.data.message === 'success') {
                this.getCmtList(parseInt(this.state.cdata.pagenation.pageSize, 10))
                document.getElementById('id-cmnt').value = ''
                this.setState({ cmtTxt: '' })
            }
            if (parseInt(rsp.data.code, 10) === 2013) {
                this.setState({ isPop: 5 })
            }
        })
    }

    delComent = t => {
        const tar = { f_stat: 2, idx_threads: t, idx_member: this.props.user.user_idx }
        Api.chgWinCmtState(tar).then(rsp => {
            if (parseInt(rsp.data.code, 10) === 200 && rsp.data.message === 'success') {
                this.getCmtList(parseInt(this.state.cdata.pagenation.pageSize, 10))
            }
        })
    }

    render() {
        const iv = this.state.cdata.eventWinBbsList ? this.state.cdata.eventWinBbsList : []
        const tc = this.state.cdata.pagenation
            ? [this.state.cdata.pagenation.totalCount, parseInt(this.state.cdata.pagenation.pageSize, 10)]
            : [0, 0]
        const isdis = !(this.state.cmtTxt.length > 9 && this.state.cmtTxt.length < 1001)
        const banFstat = !this.state.f_stat
        return (
            <article className="evtSPcomment">
                <strong className="evtDivTit" id="cmtWrap">
                    댓글 참여
                </strong>
                <div className="commentWrap">
                    <div className="commentWrap_head">
                        <strong className="cmnt-cnt">
                            <span className="clrpont3">{tc[0]} 명</span>이 참여
                        </strong>
                    </div>
                    <div className="commentWrap_icmnt">
                        <div className="commentWrap_icmnt_form">
                            {this.props.user.user_idx > 0 ? (
                                <div className="itextarea">
                                    <textarea
                                        id="id-cmnt"
                                        name="comment_msg"
                                        title="댓글작성"
                                        placeholder="※ 광고/욕설/비방이나 목적에 맞지 않는 글은 관리자에 의해 삭제될 수 있습니다.(10자 이상 등록 가능합니다.)"
                                        defaultValue={this.state.cmtTxt}
                                        onKeyUp={this.chkTextValue()}
                                    />
                                </div>
                            ) : (
                                <div className="itextarea" aria-hidden onClick={() => this.setState({ isPop: 1 })}>
                                    <textarea
                                        id="id-cmnt"
                                        name="comment_msg"
                                        title="댓글작성"
                                        placeholder="※ 광고/욕설/비방이나 목적에 맞지 않는 글은 관리자에 의해 삭제될 수 있습니다.(10자 이상 등록 가능합니다.)"
                                        onFocus={() => this.setState({ isPop: 1 })}
                                    />
                                </div>
                            )}
                            <div className="commentWrap_icmnt_form_bot">
                                <span
                                    aria-hidden
                                    className="icheck"
                                    onClick={() => this.setState({ f_stat: banFstat })}
                                >
                                    <label htmlFor="se" className={`${this.state.f_stat} chk`}>
                                        <input type="hidden" />
                                        비밀글
                                    </label>
                                    <font className={this.state.f_stat ? 'clrpont3' : 'blind'}>
                                        &nbsp;등록후 공개로 전환 할 수 없습니다.
                                    </font>
                                </span>
                                <div className="isubmit">
                                    <span className="word-cnt">
                                        <em className="clrpont3">{this.state.cmtTxt.length}</em> / 1,000
                                    </span>
                                    <button
                                        type="button"
                                        className="cmntSubmit"
                                        disabled={isdis}
                                        onClick={() => this.postNewCmt()}
                                    >
                                        등록
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="commentWrap_list">
                        {this.props.user.user_idx > 0 && (
                            <p className="myCmt">
                                <button
                                    type="button"
                                    className={this.state.isAll === 1 ? 'allCmtBtn on' : 'allCmtBtn'}
                                    onClick={() => this.isAllList(1)}
                                >
                                    전체
                                </button>
                                <button
                                    type="button"
                                    className={this.state.isAll === 2 ? 'myCmtBtn on' : 'myCmtBtn'}
                                    onClick={() => this.isAllList(2)}
                                >
                                    내가 쓴 댓글
                                </button>
                            </p>
                        )}
                        <table className="commentTable">
                            <tbody>
                                <tr>
                                    <th>작성자</th>
                                    <th>내용</th>
                                    <th>작성일</th>
                                </tr>
                                {iv.length > 0 ? (
                                    <React.Fragment>
                                        {iv.map(v => {
                                            return (
                                                <React.Fragment key={`cmtItem${v.idx_threads}`}>
                                                    <CommentItem
                                                        data={v}
                                                        isRep="tar"
                                                        user={this.props.user}
                                                        delCmt={this.delComent}
                                                        postCmt={this.postNewCmt}
                                                    />
                                                    {v.bbsRepList.length > 0 &&
                                                        v.bbsRepList.map((rv, ri) => {
                                                            const key = `cmtItem${v.idx_threads}_${ri}`
                                                            return (
                                                                <CommentItem
                                                                    data={rv}
                                                                    isRep="rep"
                                                                    user={this.props.user}
                                                                    delCmt={this.delComent}
                                                                    postCmt={this.postNewCmt}
                                                                    key={key}
                                                                />
                                                            )
                                                        })}
                                                </React.Fragment>
                                            )
                                        })}
                                    </React.Fragment>
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="evtEmp">
                                            등록된 댓글이 없습니다.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {tc[0] > tc[1] ? (
                            <button type="button" className="epMoreBtn" onClick={() => this.getCmtList(tc[1] + 25)}>
                                더보기 <i className="icon-add_circle" />
                            </button>
                        ) : (
                            <a className="epMoreBtn" href="#cmtWrap">
                                위로 <i className="icon-angle-double-up" />
                            </a>
                        )}
                    </div>
                </div>
                {this.state.isPop === 3 && (
                    <table id="lyrPop" className="bgdark">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="PopMain artPop">
                                        <strong>로그인이 필요한 서비스입니다.</strong>
                                        <div className="popDefBtns">
                                            <button
                                                type="button"
                                                className="icon-X_close"
                                                onClick={() => this.setState({ isPop: 0 })}
                                            />
                                            <button
                                                type="button"
                                                className="confBtn"
                                                onClick={() => this.setState({ isPop: 0 })}
                                            >
                                                닫기
                                            </button>
                                            <a className="styPBg" href="//sso.pping.kr/" title="로그인 페이지로 이동">
                                                로그인 하러가기
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )}
                {this.state.isPop === 5 && (
                    <table id="lyrPop" className="bgdark">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="PopMain artPop">
                                        <strong>이벤트 당첨자만 참여 가능합니다.</strong>
                                        <div className="popDefBtns">
                                            <button
                                                type="button"
                                                className="icon-X_close"
                                                onClick={() => this.setState({ isPop: 0 })}
                                            />
                                            <button
                                                type="button"
                                                className="confBtn"
                                                onClick={() => this.setState({ isPop: 0 })}
                                            >
                                                닫기
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </article>
        )
    }
}
export default Comment
